// Modules
import styled from "styled-components"

export const ContainerSpaceBetween = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`
export const ContainerRight = styled.div`
  display: flex;
  justify-content: end;
`
